import React from 'react'

import { Section, Properties, Blurred, Empty, Text } from 'components';
import { Button, Icon } from 'semantic-ui-react';

import { ModalEditDeviceInfos } from 'modals';

import { Typeof } from 'utils';

class SectionDevice extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showEditModal: false
    };

    this.toggleEditModal = this.toggleEditModal.bind(this);
    this.handleCloseEditModal = this.handleCloseEditModal.bind(this);
  }

  toggleEditModal() {

    //Show modal
    this.setState({
      showEditModal: !this.state.showEditModal
    });
  }

  handleCloseEditModal(infos) {

    if (Typeof.object(infos)) {

      //Update locally
      this.props.device.infos = infos;
    }

    //Hide modal
    this.toggleEditModal();
  }

  render() {

    const device = this.props.device;

    let infosProperties = [
      {
        name: 'Modèle',
        value: Typeof.string(device.infos.model) ? <Text style={{"mono" : true}}>{device.infos.model}</Text> : <Empty />
      },
      {
        name: 'Numéro de série',
        value: Typeof.string(device.infos.serial_number) ? <Text style={{"mono" : true}}>{device.infos.serial_number}</Text> : <Empty />
      },
      {
        name: 'Gravure',
        value: Typeof.string(device.infos.engraving) ? <i>{device.infos.engraving}</i> : <Empty />
      },
      {
        name: 'Code de déverouillage',
        value: Typeof.string(device.infos.lock_pin) ? <Blurred value={device.infos.lock_pin} /> : <Empty />
      },
      {
        name: 'Mot de passe administrateur',
        value: Typeof.string(device.infos.admin_password) ? <Blurred value={device.infos.admin_password} /> : <Empty />
      }
    ];


    return (
      <Section title={<span><Icon name="tablet" />iPad</span>} actions={
        <Button icon="edit" circular onClick={this.toggleEditModal} />
      } collapsible collapsed>

        <Properties properties={infosProperties} />

        {/* Device infos edit modal */}
        {this.state.showEditModal &&
          <ModalEditDeviceInfos onClose={this.handleCloseEditModal} device={device} />
        }

      </Section>


    );
  }
}

export default SectionDevice;
